import { FC } from "react";
import { useTranslation } from "react-i18next";

import { Panel } from "../../../../components/panel/Panel";
import { formatNumberWithSpaces } from "../../../../components/price/Price";
import { DagCommunityViewQuery, ViewerQuery } from "../../../../graphql/schema";
import { AsyncImg } from "../../../../components/async-img/AsyncImg";

import styles from "./dag-community-view.module.scss";

export interface DagCommunityOverviewProps {
  me: ViewerQuery | undefined;
  totalDagsQuery: DagCommunityViewQuery | undefined;
  className?: string;
}

export const DagCommunityOverview: FC<DagCommunityOverviewProps> = ({ me }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className={styles["src-content-container"]}>
        <div className={styles["text-container"]}>
          <p>
            An area for community members where the features and benefits they unlocked with their membership packages
            are being brought together. This includes both existing and upcoming.
          </p>
          <p>
            Additionally, who has not transferred their dags to their personal wallet will be able to access their
            balances in this section. There is no more need to migrate to Grow, as the holdings will be accessible from
            here. For ease of use, separate website for Grow will not be functional any longer. The link to crypto card
            can also be found here shortly.
          </p>
          <p>
            In case you feel you did not get enough value out of the membership and courses, you will have the
            opportunity to convert your received bonus coins to store credit for the amount of your membership and opt
            for another product or gift card.
          </p>
        </div>
        <Panel className={styles["scr-wrap"]} contentClassName={styles["wrap-content"]}>
          <Panel
            className={styles["scr-panel"]}
            contentClassName={styles["scr-content"]}
            panelStyle="TERTIARY"
            width={0}
          >
            <AsyncImg src="/images/IconDagcoin.svg" className={styles["scr-logo"]} width={150} height={150} />
            <span className={styles["scr-credit"]}>
              {me?.viewer ? (
                <>
                  {formatNumberWithSpaces(me?.viewer?.coinAccountBalance ?? 0)}
                  <br />
                  <span className={styles["scr-label"]}>{t("DAGS")}</span>
                </>
              ) : (
                // empty placeholder to prevent content 'jumping' when data hasn't loaded
                <div style={{ height: "37px" }} />
              )}
            </span>
          </Panel>
        </Panel>
      </div>
    </>
  );
};
